<template>
  <div class="Com_12">
    <title1 type="2" title="站点监控"> </title1>
    <div class="Com_12_bottom22" style="width: 565px; height: 384px">
      <div class="imgbox" v-for="(item,index) in arrlist" :key="index">
		  <img v-if="item.type == 'img'" class="img" :src="item.url" alt="">
      <video class="video" muted autoplay loop :src="item.url" v-else-if="item.type == 'video'"></video>
	  </div>
    </div>
  </div>
</template>
    
    <script>
import title1 from "@/views/exposition/components/title3";
import { dataInterface } from "@/api/dataInterfaceApi";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
export default {
  components: {
    title1,
    MyEcharts
  },
  data() {
    return {
		arrlist:[
			// 'https://sass.gclme.com/api/file/Image/annex/20231228_63631866ae474bf2b9f03c3a22110788.png',
      {
        type: 'video',
        url: require('@/assets/Video/photo1.mp4')
      },
      {
        type: 'img',
        url: 'https://sass.gclme.com/api/file/Image/annex/20231228_3a806a18452541d5b61bf69ee22ab2e3.png',
      },
      {
        type: 'img',
        url:'https://sass.gclme.com/api/file/Image/annex/20231228_7d66696b477b442e80a5cd8688de2a10.png',
      },
      {
        type: 'img',
        url: 'https://sass.gclme.com/api/file/Image/annex/20231228_7f40bafece4b4b65888ed98f6e83f19d.png'
      }
		],
      showcdata: false,
      cdata: {
        //
        tooltip: {
          trigger: "axis",
        },
        legend: {
          itemWidth: 12,
          itemHeight: 8,
          data: ["尖", "峰", "平", "谷"],
        },
        xAxis: {
          data: ["10/14", "10/15", "10/16", "10/17", "10/18", "10/19", "10/20"],
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "kWh  ",
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "尖",
            type: "bar",
            barWidth: 13,
            stack: "使用情况",
            data: [705, 720, 736, 710, 710, 720, 730],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FFCE51",
                  },
                  {
                    offset: 1,
                    color: "#2E4039",
                  },
                ]),
              },
            },
          },
          {
            name: "峰",
            type: "bar",
            stack: "使用情况",
            data: [505, 520, 536, 510, 510, 520, 535],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#0B4C5D", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#0C809D", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0DB9E5", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
          {
            name: "平",
            type: "bar",
            stack: "使用情况",
            data: [385, 392, 398, 395, 392, 390, 395],
            itemStyle: {
              normal: { color: "#FFFFFF" },
            },
          },
          {
            name: "谷",
            type: "bar",
            stack: "使用情况",
            data: [190, 196, 197, 195, 196, 197, 195],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#15F5C9", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#1E927C", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#1B3633", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let params = {
        enCode: "chuneng-quanguo-fsfdlsjfb",
        "@energyId": "ES00001",
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "time1");
          if (res) {
            let data = [];
            let data2 = [];
            let data3 = [];
            let data4 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_date);
              data.push(item.j_discharge_elect);
              data2.push(item.f_discharge_elect);
              data3.push(item.p_discharge_elect);
              data4.push(item.g_discharge_elect);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.cdata.series[2].data = data3;
            this.cdata.series[3].data = data4;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.Com_12 {
  .Com_12_bottom22 {
    display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	.imgbox{
		width: 270px;
		height: 180px;
		margin-top: 8px;
		.img{
			width: 100%;
			height: 100%;
		}
    .video{
      width: 100%;
      height: 100%;
      object-fit:fill;
    }
	}
  }
}
</style>